riot.tag2('bbc-notifications', '<bbc-notifications-bell main-app="{opts.mainApp}" state="{this.state}" alert="{this.alert}"></bbc-notifications-bell> <bbc-notifications-drawer main-app="{opts.mainApp}" component-app="{this}" state="{this.state}" notifications="{this.notifications}" reached-end="{this.reachedEnd}" loading-more="{this.loadingMore}" error="{this.error}" orb="{opts.orb}" load-onboarding="{this.loadOnboarding}" view="{this.view}"></bbc-notifications-drawer>', '', '', function(opts) {
'use strict';

var _this = this;

require('whatwg-fetch');
var config = require('../config');
var notificationsAnalytics = require('../analytics');
var NotificationsModelClass = require('../models/NotificationsModel').NotificationsModel;
var userPreferencesModel = require('../models/UserPreferences');
var StateClass = require('../models/UserState').UserState;

var state = new StateClass();
console.log('State module', state);

this.alert = false;
this.notifications = [];
this.reachedEnd = false;
this.loadingMore = false;
this.error = {};
this.loadOnboarding = false;
this.view = 'home';

this.loadState = function () {
    return state.load().then(function (stateData) {
        console.log('State', stateData);
        _this.update({ state: stateData });

        if (stateData.signedIn === true) {
            if (stateData.onboarded === false || stateData.onboarded === true && stateData.policyIssue) {
                _this.update({ alert: true });
            } else if (stateData.onboarded === true && !stateData.policyIssue) {
                userPreferencesModel.fetch(false).then(function () {
                    return _this.initModel();
                });
            }
        }
    }).catch(function (err) {
        console.error('State failed to load', err);
        notificationsAnalytics.log('error1-retrieve-fail', 'notifications-error');
        _this.setError('main', 'hub');
    }).then(function () {
        _this.trigger('stateLoaded');
    });
};

this.on('mount', this.loadState);

this.on('notificationsUserOnboardedOutsideDrawer', function () {
    console.log('noticed that user has been onboarded OUTSIDE PANEL');
    this.loadState();
});

this.initModel = function () {
    if (!_this.notificationsModel) {
        console.log('Instantiating model class');
        _this.notificationsModel = new NotificationsModelClass();
        console.log('Fetching notifications');
        _this.fetchNotifications();
        window.setInterval(_this.fetchNotifications, config.env.notificationsPollingInterval);
        window.setInterval(_this.fetchPreferences, config.env.preferencesPollingInterval);
    }
};

this.fetchNotifications = function (fetchNext) {
    if (fetchNext) {
        _this.update({ loadingMore: true });
    }

    var prevNotificationsLength = _this.notifications.length;

    return _this.notificationsModel.fetch(fetchNext).catch(function (err) {
        notificationsAnalytics.log('error2-update-fail', 'notifications-error');
        _this.setError('main', 'hub');
        throw err;
    }).then(function (response) {
        if (!response) {
            return;
        }

        var notifications = response.notifications;
        var reachedEnd = response.reachedEnd;

        console.log('Notifications', notifications.length, notifications, reachedEnd ? 'ENDED' : '...');

        _this.notifications = notifications;
        if (reachedEnd) {
            _this.reachedEnd = reachedEnd;
        }
        _this.loadingMore = false;

        var hasNew = false;
        notifications.forEach(function (i) {
            if (i.status === 'new') {
                hasNew = true;
            }
        });

        console.warn('Has new?', hasNew);
        if (hasNew) {
            notificationsAnalytics.logNewNotifications(_this.notifications, opts.mainApp);

            if (notifications.length > prevNotificationsLength) {
                _this.alert = true;
            }
        }

        _this.removeError('main');

        _this.update();
        _this.trigger('fetchedNotifications');
    });
};

this.fetchPreferences = function () {
    console.log('Refetching preferences from interval');
    userPreferencesModel.fetch().catch(function (err) {
        notificationsAnalytics.log('error2-update-fail', 'notifications-error');
        _this.setError('main', 'hub');
        throw err;
    }).then(function () {
        _this.removeError('main');
    });
};

this.setError = function (type, val) {
    console.error('Displaying error', type, val);
    _this.error[type] = val;
    _this.update();
};

this.removeError = function (type) {
    delete _this.error[type];
    _this.update();
};

this.resetNotifications = function () {
    _this.update({ notifications: [], reachedEnd: false });
    _this.notificationsModel.reset();
    _this.fetchNotifications();
};

this.drawerStateChangedCallback = function (newState) {
    console.log('Drawer is now', newState);
    _this.update({ alert: false });

    if (newState === 'hidden') {
        console.log('LOGGING drawer been closed.');
        notificationsAnalytics.log('close-pane', 'notifications-icon');

        if (_this.notificationsModel) {
            var markedSeen = _this.notificationsModel.markAllAsSeen();
            _this.update({
                notifications: markedSeen
            });
        }
    } else {
        // drawer is being opened
        console.log('DRAWER is opening.');
        _this.update({ view: 'home' });
        if (_this.state) {
            console.log('got STATE');
            if (_this.state.signedIn === false) {
                console.log('SIGNED OUT');
                // signed out user
                notificationsAnalytics.log('upsell', 'notifications-icon');
            } else if (_this.state.onboarded) {
                // signed in, onboarded
                console.log('DRAWER IS OPENING AND USER IS ONBOARDED.');

                userPreferencesModel.updateRead(true);
                notificationsAnalytics.logNewNotifications(_this.notifications, opts.mainApp);
            } else if (Object.keys(_this.error).length === 0) {
                console.log('NOT ONBOARDED');
                // not onboarded and no error, load 1.NotificationsMain now
                _this.update({ loadOnboarding: true });
            }
        }
    }
    _this.trigger('drawerStateChanged', newState);
};

this.on('updated', function () {
    opts.mainApp.updateWrapperMaxHeight();
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications.tag
 ** module id = 32
 ** module chunks = 0
 **/